import React from "react";
import { withStyles } from "@mui/styles";

import FormHeader from "../../components/formHeader/FormHeader";
import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import Button from "../../components/button/Button";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";

const isInvalidName = (name) => !name;

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function AddAdjustmentReasonForm({
  classes,
  payload,
  storePayload,
  onSubmit,
  errorMessage,
  submitting,
}) {
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  return (
    <div className={classes.section}>
      <div className={classes.setupInformation}>
        <FormHeader title="Add adjustment reason" />
      </div>
      <SingleLineTextInput
        label="REASON"
        onChange={(value) => storePayload({ ...payload, reason: value })}
        showInvalidInput={submitAttempted && isInvalidName(payload.reason)}
      />
      <ErrorMessage message={errorMessage} />
      {onSubmit && (
        <Button
          title="Next"
          onClick={() => {
            setSubmitAttempted(true);
            onSubmit(payload);
          }}
          submitting={submitting}
        />
      )}
    </div>
  );
}

export default withStyles(styles)(AddAdjustmentReasonForm);
